<template>
  <!-- Desktop version -->
  <Motion
    as="div"
    :initial="{ opacity: 0, y: 20 }"
    :animate="{ opacity: 1, y: 0 }"
    :whileHover="{
      scale: 1.02,
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
      filter: 'brightness(0.9)',
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      }
    }"
    :transition="{
      duration: 0.5,
      backgroundColor: {
        delay: motionDelay / 1000,
      },
      opacity: {
        delay: motionDelay / 1000,
      },
      y: {
        delay: motionDelay / 1000,
      },
      ease: 'easeOut'
    }"
    class="flex flex-col justify-between lg:col-start-4 lg:col-end-5 lg:row-start-1 lg:row-end-[4] bg-[rgb(250,236,215)] rounded-20 font-basic cursor-pointer lg:py-6 py-4 lg:px-5 px-4 relative overflow-hidden"
    @click="goToPage"
  >
    <!-- 상단: Title -->
    <div class="flex items-center justify-between">
      <p class="font-normal font-basic text-sm sm:text-lg lg:text-xl 2xl:text-[26px] tracking-tight">
        문의사항이 있나요?
      </p>
      <img
        :src="require('@/assets/ic-plane-black.png')"
        alt="contact"
        class="w-4 h-4 sm:w-12 sm:h-12"
      />
    </div>

    <!-- 하단: Subtitle -->
    <div>
      <p class="font-semibold font-paperlogy text-xl sm:text-3xl xl:text-4xl 2xl:text-5xl whitespace-pre-wrap">Contact Us</p>
    </div>
  </Motion>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useResponsive } from '@/composables/useResponsive'
import { Motion } from 'motion-v'

defineProps({
  motionDelay: {
    type: Number,
    default: 0
  }
})

const router = useRouter()

// Responsive state
const { isMobile } = useResponsive()

const goToPage = () => {
  router.push('/contactus')
}
</script>
